import { ArrowRightLeft } from 'lucide-react'

import { Card, CardContent, CardHeader, CardTitle, Spinner } from '@/components/ui'
import { useSyncState } from '@/contexts/SessionContext'

/** Connected again for another branch: shown while the old branch's waiting sales go up (POS.md §18.2). */
export const MovingBranchPage = () => {
  const { pending } = useSyncState()
  return (
    <div className="flex h-dvh items-center justify-center bg-frame p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ArrowRightLeft className="size-5" /> Moving to the new branch
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm">
          <p>
            This device was connected for another branch. Its sales from the old branch are sent first
            {pending > 0 ? ` (${pending} waiting)` : ''}; then you choose its new terminal.
          </p>
          <p className="flex items-center gap-2 text-muted-foreground">
            <Spinner className="size-4" /> Needs a connection. It retries on its own.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
